/*
  Set of css classes for managing basic elements data capture rules
  https://help.fullstory.com/hc/en-us/articles/360044349073-FullStory-Private-by-Default#01FHE22KSQY5TEKVXQ0B8SB6HA
*/
export default {
  EXCLUDE: 'fs-exclude',
  MASK: 'fs-mask',
  UNMASK: 'fs-unmask',
}
